import { render, staticRenderFns } from "./TrekkerList.vue?vue&type=template&id=623df518&"
import script from "./TrekkerList.vue?vue&type=script&lang=js&"
export * from "./TrekkerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports